import type { TaskStatus, TaskPriority, StatusConfig, PriorityConfig, LegacyStatus } from '../types/task.types';

export const STATUS_CONFIG: Record<TaskStatus, StatusConfig> = {
    backlog: {
        label: 'Backlog',
        color: '#94a3b8',
        bgColor: '#f1f5f9',
        icon: 'CircleDashed',
        order: 0,
    },
    todo: {
        label: 'Todo',
        color: '#3b82f6',
        bgColor: '#eff6ff',
        icon: 'Circle',
        order: 1,
    },
    in_progress: {
        label: 'In Progress',
        color: '#f59e0b',
        bgColor: '#fffbeb',
        icon: 'Timer',
        order: 2,
    },
    in_review: {
        label: 'In Review',
        color: '#8b5cf6',
        bgColor: '#f5f3ff',
        icon: 'Eye',
        order: 3,
    },
    done: {
        label: 'Done',
        color: '#22c55e',
        bgColor: '#f0fdf4',
        icon: 'CheckCircle',
        order: 4,
    },
};

export const PRIORITY_CONFIG: Record<TaskPriority, PriorityConfig> = {
    urgent: {
        label: 'Urgent',
        color: '#ef4444',
        icon: 'AlertTriangle',
    },
    high: {
        label: 'High',
        color: '#f97316',
        icon: 'ArrowUp',
    },
    medium: {
        label: 'Medium',
        color: '#eab308',
        icon: 'Minus',
    },
    low: {
        label: 'Low',
        color: '#3b82f6',
        icon: 'ArrowDown',
    },
    none: {
        label: 'No Priority',
        color: '#94a3b8',
        icon: 'MoreHorizontal',
    },
};

export const STATUS_ORDER: TaskStatus[] = ['backlog', 'todo', 'in_progress', 'in_review', 'done'];

export const PRIORITY_ORDER: TaskPriority[] = ['urgent', 'high', 'medium', 'low', 'none'];

// Maps legacy status values to the new status system
export const LEGACY_STATUS_MAP: Record<LegacyStatus, TaskStatus> = {
    pending: 'todo',
    completed: 'done',
};

// Maps new statuses back to legacy for backward compatibility
export const STATUS_TO_LEGACY: Partial<Record<TaskStatus, LegacyStatus>> = {
    todo: 'pending',
    done: 'completed',
};

export const DEFAULT_PAGE_SIZE = 20;

export const VALID_ADMIN_ROLES = ['SuperAdmin', 'Admin', 'Evaluator'] as const;

export const KEYBOARD_SHORTCUTS = {
    NEW_TASK: 'n',
    CYCLE_STATUS: 's',
    CYCLE_PRIORITY: 'p',
    DELETE: 'Delete',
    CLOSE_PANEL: 'Escape',
    NAVIGATE_UP: 'k',
    NAVIGATE_DOWN: 'j',
    OPEN_DETAIL: 'Enter',
    COMMAND_PALETTE: 'k', // Used with Cmd/Ctrl modifier
    SELECT_ALL: 'a', // Used with Cmd/Ctrl modifier
} as const;

export const DEBOUNCE_SEARCH_MS = 300;

export const OPTIMISTIC_UPDATE_WINDOW_MS = 5000;

export const DETAIL_PANEL_WIDTH = 640;
